const toDayStart = (value: Date): Date =>
  new Date(Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate()));

export const resolveTimestamp = (value: Date | string | null | undefined): Date | null => {
  if (!value) return null;
  const dateValue = value instanceof Date ? value : new Date(value);
  return Number.isNaN(dateValue.getTime()) ? null : dateValue;
};

export const resolveFrequencyPerDay = (
  total: number | null | undefined,
  earliest: Date | null,
  latest: Date | null,
): number | null => {
  if (!total || !earliest || !latest) return null;
  const start = toDayStart(earliest);
  const end = toDayStart(latest);
  const dayMs = 24 * 60 * 60 * 1000;
  const diffDays = Math.floor((end.getTime() - start.getTime()) / dayMs) + 1;
  const span = Math.max(1, diffDays);
  return total / span;
};
